import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ui:error-boundary]", { error, errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  handleGoHome = () => {
    window.history.pushState({}, "", "/");
    window.dispatchEvent(new PopStateEvent("popstate"));
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container py-5">
          <div className="alert alert-danger" role="alert">
            <h5 className="mb-2">Ocorreu um erro inesperado</h5>
            <p className="mb-3">
              A aplicação encontrou uma falha, mas você pode continuar sem
              recarregar a página.
            </p>
            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={this.handleRetry}
              >
                Tentar novamente
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleGoHome}
              >
                Ir para o início
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;